import { Component, Injector, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { ApComplexModal } from 'webcommon/core-ui';
import { AddressDto, FcFacilityPortalPersonListItemDto } from 'webcommon/shared';
import { FindControlIdService } from 'webcommon/legacy-common';
import { ApFindControlService } from '../../ap-findcontrol.service';

@Component({
  selector: 'fc-copy-contact-info-list-modal',
  templateUrl: './fc-copy-contact-info-list-modal.component.html',
  styleUrls: ['./fc-copy-contact-info-list-modal.component.less']
})
export class FcCopyContactInfoListModalComponent extends ApComplexModal<any> implements OnInit {
  public baseId = 'fc-copy-contact-info';
  public isDisabled = false;
  public listItemName = 'Copy Contact Info';

  public mode: number;

  public personControl: FormControl = new FormControl('');
  public addressesCheckboxControl: FormControl = new FormControl(true);
  public phoneNumbersCheckboxControl: FormControl = new FormControl(true);
  public emailAddressesCheckboxControl: FormControl = new FormControl(true);
  public addressDataControl: FormControl = new FormControl<Partial<AddressDto | null>>({});
  public phoneNumberDataControl: FormControl = new FormControl({});
  public emailOneDataControl: FormControl = new FormControl('');
  public emailTwoDataControl: FormControl = new FormControl('');
  public form: FormGroup = new FormGroup({
    person: this.personControl,
    addresses: this.addressesCheckboxControl,
    phoneNumbers: this.phoneNumbersCheckboxControl,
    emailAddresses: this.emailAddressesCheckboxControl,
    addressData: this.addressDataControl,
    phoneData: this.phoneNumberDataControl,
    emailOneData: this.emailOneDataControl,
    emailTwoData: this.emailTwoDataControl,
  });

  public personDataControl: FormControl = new FormControl<null | FcFacilityPortalPersonListItemDto>(null);

  public selectedPersonPks: string[] = [];


  constructor(
    injector: Injector,
    private apFindControlService: ApFindControlService,
  ) {
    super(injector);
  }

  public override ngOnInit(): void {
    super.ngOnInit();
    this.checkboxValueChanged();
  }

  public onPersonDataPopulate(personArray: FcFacilityPortalPersonListItemDto[]): void {
    const personData: FcFacilityPortalPersonListItemDto = {...personArray[0]};

    if (personData && personArray[0]) {
      this.apFindControlService
        .getItem<FcFacilityPortalPersonListItemDto>(FindControlIdService.ViewFindPerson, personData.PersonUid)
        .pipe(
          takeUntil(this.onDestroy$)
        )
        .subscribe((fullPersonData) => {
          this.selectedPersonPks.push(fullPersonData.PersonUid);
          this.personDataControl.setValue(fullPersonData);
          if (this.addressesCheckboxControl.value) {
            this.addressDataControl.setValue(this.personDataControl.value?.Address1);
          } else {
            this.addressDataControl.setValue(null);
          }
          if (this.phoneNumbersCheckboxControl.value) {
            this.phoneNumberDataControl.setValue({
              Phone1: this.personDataControl.value?.Phone1,
              Phone2: this.personDataControl.value?.Phone2,
              Phone3: this.personDataControl.value?.Phone3,
              Phone4: this.personDataControl.value?.Phone4,
            });
          } else {
            this.phoneNumberDataControl.setValue(null);
          }
          if (this.emailAddressesCheckboxControl.value) {
            this.emailOneDataControl.setValue(this.personDataControl.value?.Email1);
            this.emailTwoDataControl.setValue(this.personDataControl.value?.Email2);
          } else {
            this.emailOneDataControl.setValue(null);
            this.emailTwoDataControl.setValue(null);
          }
        });
    } else {
      this.personDataControl.setValue(null);
    }
  }


  public onCancel(): void {
    this.apClose({result: false});
  }

  public onSave(): void {
    const values = this.form.getRawValue();
    const copyContactInfoDto = {
      address: values.addressData,
      phone: values.phoneData,
      emailOne: values.emailOneData,
      emailTwo: values.emailTwoData,
    };

    this.apClose({result: copyContactInfoDto});
  }

  private checkboxValueChanged(): void {
    this.form.get('addresses')?.valueChanges.pipe(
      this.takeUntilDestroy()
    ).subscribe((addressState) => {
      if (addressState) {
        this.addressDataControl.setValue(this.personDataControl.value?.Address1);
      } else {
        this.addressDataControl.setValue(null);
      }
      this.markFormAsPristine();
    });

    this.form.get('phoneNumbers')?.valueChanges.pipe(
      this.takeUntilDestroy()
    ).subscribe((phoneState) => {
      if (phoneState) {
        this.phoneNumberDataControl.setValue({
          Phone1: this.personDataControl.value?.Phone1,
          Phone2: this.personDataControl.value?.Phone2,
          Phone3: this.personDataControl.value?.Phone3,
          Phone4: this.personDataControl.value?.Phone4,
        });
      } else {
        this.phoneNumberDataControl.setValue(null);
      }
      this.markFormAsPristine();
    });

    this.form.get('emailAddresses')?.valueChanges.pipe(
      this.takeUntilDestroy()
    ).subscribe((emailState) => {
      if (emailState) {
        this.emailOneDataControl.setValue(this.personDataControl.value?.Email1);
        this.emailTwoDataControl.setValue(this.personDataControl.value?.Email2);
      } else {
        this.emailOneDataControl.setValue(null);
        this.emailTwoDataControl.setValue(null);
      }
      this.markFormAsPristine();
    });

  }

  private markFormAsPristine(): void {
    if (!this.selectedPersonPks.length) {
      this.form.markAsPristine();
    } else {
      this.form.markAsDirty();
    }
  }
}
